module.exports = __webpack_public_path__ + "img/hr-tree-04-c-trunk.03e6e159.png";